import { render, staticRenderFns } from "./PlannedLevelSkills.vue?vue&type=template&id=77545642&scoped=true&"
import script from "./PlannedLevelSkills.vue?vue&type=script&lang=js&"
export * from "./PlannedLevelSkills.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77545642",
  null
  
)

export default component.exports